import React, { useState, useEffect, useRef } from 'react';
import { Alert, Card, Col, Container, Input, Label, Row, Button, Modal, ModalBody, NavItem } from 'reactstrap';
import axios from 'axios';
import ReactInputVerificationCode from 'react-input-verification-code';
import { useInterval } from "usehooks-ts";
// import ReCAPTCHA from 'react-google-recaptcha'

import logoTelkom from "../../../assets/images/telkom/logoACI.png";
import Welcome from "../../../assets/images/telkom/welcomeNew.png";

const CoverSignInterview = () => {
    document.title = "Login Assessor";

    if (localStorage.getItem('user') != null) {
        window.localStorage.clear()
    }
    if (sessionStorage.getItem('user') != null) {
        window.location.href = '/i1';
    }

    const [email, setEmail] = useState('');
    const [errorEmail, setErrorEmail] = useState('');
    const [password, setPassword] = useState('');
    const [errorPassword, setErrorPassword] = useState('');
    const [errorSubmit, setErrorSubmit] = useState(true);
    const [errorMessage, setErrorMessage] = useState('');
    const [errorChange, setErrorChange] = useState(true);
    const [errorMessageChange, setErrorMessageChange] = useState('');
    const [errorOTP, setErrorOTP] = useState(true);
    const [errorMessageOTP, setErrorMessageOTP] = useState('');
    const [showPass, setShowPass] = useState(false);



    // 15 MEI 2023 //
    const [modalChangePassword, setModalChangePassword] = useState(false);
    const [getApiKey, setGetApiKey] = useState("")
    const [passwordCurrent, setPasswordCurrent] = useState('');
    const [passwordNew, setPasswordNew] = useState('');
    const [passwordConfirm, setPasswordConfirm] = useState('');

    // --- OTP After Login --- //
    const [otp, setOTP] = useState('');

    // --- Open MODAL OTP After Login --- //
    const [modalOTP, setModalOTP] = useState(false);

    // --- Get Data After Login --- //
    const [userID, setUserID] = useState("");
    const [emailEncrypt, setEmailEncrypt] = useState("");
    const [namaEncrypt, setNamaEncrypt] = useState("");

    // --- is First Login ? --- //
    const [isFirstLogin, setIsFirstLogin] = useState(null);

    // const [modalReCAPTCHA, setModalReCAPTCHA] = useState(false);

    // ReCAPTCHA
    // const captchaRef = useRef(null)

    const changeEmail = (event) => {
        const value = event.target.value
        setEmail(value)
        if (!value) {
            setErrorEmail('Maaf, email tidak boleh kosong!')
        } else {
            setErrorEmail('')
        }
    }

    const changePassword = (event) => {
        const value = event.target.value
        setPassword(value)
        if (!value) {
            setErrorPassword('Maaf, password tidak boleh kosong!')
        } else {
            setErrorPassword('')
        }
    }

    const changePasswordCurrent = (event) => {
        const value = event.target.value
        setPasswordCurrent(value)
        if (!value) {
            setErrorPassword('Maaf, password tidak boleh kosong!')
        } else {
            setErrorPassword('')
        }
    }

    const changePasswordNew = (event) => {
        const value = event.target.value
        setPasswordNew(value)
        if (!value) {
            setErrorPassword('Maaf, password tidak boleh kosong!')
        } else {
            setErrorPassword('')
        }
    }

    const changePasswordConfirm = (event) => {
        const value = event.target.value
        setPasswordConfirm(value)
        if (!value) {
            setErrorPassword('Maaf, password tidak boleh kosong!')
        } else {
            setErrorPassword('')
        }
    }

    const shower = () => {
        setShowPass(!showPass);
    }

    // -- Fungsi Get Error Message dari Error Code -- //
    const getErrorMessage = (errorCode) => {
        switch (errorCode) {
            case "E1":
                return "Sesi Anda telah berakhir. Silakan login kembali.";
            case "CE1":
            case "CE2":
                return "Data tidak valid. Silakan periksa kembali.";
            case "IF1":
                return "Data yang diminta tidak tersedia.";
            case "CE3":
                return "Kode tidak dapat digunakan.";
            case "SE1":
                return "Email tidak dapat digunakan.";
            case "PM1":
                return "Email atau password tidak valid.";
            case "PM2":
                return "Konfirmasi password tidak sesuai.";
            case "IF2":
                return "Data tidak lengkap.";
            case "EF1":
                return "Permintaan tidak dapat diproses.";
            case "OM1":
                return "Kode verifikasi tidak valid.";
            case "NC1":
                return "Konfirmasi password tidak sesuai.";
            case "AP1":
                return "Terjadi kesalahan sistem. Silakan coba kembali.";
            case "EX1":
                return "File tidak dapat diproses.";
            case "NX1":
                return "File belum dipilih.";
            case "AK1":
                return "Akses tidak valid.";
            case "FS1":
                return "Ukuran file melebihi batas maksimum yang diizinkan.";
            case "SQ1":
                return "Terjadi kesalahan sistem. Silakan coba kembali.";
            case "MN1":
                return "Gagal memproses file. Silakan coba kembali.";
            case "EV1":
                return "Data yang dikirim tidak valid.";
            case "NM1":
                return "Gagal mengirim notifikasi. Silakan coba kembali.";
            case "RL1":
                return "Terlalu banyak permintaan. Silakan coba kembali beberapa saat lagi.";
            default:
                return errorCode;
        }
    }

    const [modalLimitLogin, setModalLimitLogin] = useState(false)

    const loginButton = () => {

        // if (captchaRef.current.getValue() !== "") {
        const data = JSON.stringify({
            email: email,
            password: password,
        });

        const config = {
            method: 'post',
            url: `${process.env.REACT_APP_BASE_ENDPOINT_BACKEND}/assesor/login`,
            headers: {
                'Content-Type': 'application/json',
            },
            data: data,
        };

        axios(config).then((response) => {
            const hasil = response
            const modifHasil = {
                ...hasil,
                results: {
                    ...hasil.results,
                    nama: hasil.results.nama,
                    email: hasil.results.email
                }
            };
            console.log(hasil)
            console.log(modifHasil)

            
            if (response && response.results) {
                let emailEnc = response.results.email;
                let userId = response.results.id;
                let namaEnc = response.results.nama;

                let isFL = response.results.otp
                setIsFirstLogin(isFL)

                setUserID(userId)
                setEmailEncrypt(emailEnc)
                setNamaEncrypt(namaEnc)

                // Reset error states
                setErrorOTP(true);
                setErrorMessageOTP('');
                setOTP('');
                
                setModalOTP(true)
            }

            // if (modifHasil.results.otp === null) {
            //     setModalChangePassword(true)
            //     setGetApiKey(modifHasil.results.token)
            // } else {
            //     sessionStorage.setItem('user', JSON.stringify(modifHasil))
            //     window.location.href = '/i1'
            // }

        }).catch((error) => {
            console.log(error)
            if (error.response && error.response.data && error.response.data.error) {
                
                const errorCode = error.response.data.error;
                
                if (errorCode == "Request failed with status code 429" || errorCode === "RL1") {
                    setModalLimitLogin(true)
                } else {
                    const message = getErrorMessage(errorCode);
                    setErrorMessage(message);
                    setErrorSubmit(false);
                    setTimeout(() => {
                        setErrorSubmit(true)
                        setErrorMessage('')
                    }, 5000)
                }
            } else {
                setErrorMessage("Terjadi kesalahan. Silakan coba kembali.");
                setErrorSubmit(false);
                setTimeout(() => {
                    setErrorSubmit(true)
                    setErrorMessage('')
                }, 5000)
            }
        })
        // } else {
        //     setModalReCAPTCHA(true)
        // }
    }

    const verifyOTP = () => {
        let data = JSON.stringify({
            "user_id": userID,
            "email": emailEncrypt,
            "name": namaEncrypt,
            "otp_code": otp
        });

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${process.env.REACT_APP_BASE_ENDPOINT_BACKEND}/assesor/verifikasiKodeOtpAssessor`,
            headers: { 
                'Content-Type': 'application/json'
            },
            data : data
        };

        axios.request(config)
            .then((response) => {

                if(response.status == 200) {
                    // Reset error states
                    setErrorOTP(true);
                    setErrorMessageOTP('');
                    
                    if(isFirstLogin == null) {
                        setModalChangePassword(true)
                        setGetApiKey(response.token)
                    } else {
                        sessionStorage.setItem('user', JSON.stringify({results: {id: userID, nama:namaEncrypt, email: emailEncrypt, token: response.token, api_key: response.token}}));
                    window.location.href = '/i1';
                    }

                    setModalOTP(false);
                }
            })
            .catch((error) => {
                console.log(error);
                
                if (error.response && error.response.data && error.response.data.error) {
                    const errorCode = error.response.data.error;
                    const message = getErrorMessage(errorCode);
                    setErrorMessageOTP(message);
                    setErrorOTP(false);
                    setTimeout(() => {
                        setErrorOTP(true)
                        setErrorMessageOTP('')
                    }, 5000)
                } else {
                    setErrorMessageOTP("Terjadi kesalahan. Silakan coba kembali.");
                    setErrorOTP(false);
                    setTimeout(() => {
                        setErrorOTP(true)
                        setErrorMessageOTP('')
                    }, 5000)
                }
            });
    }

    const firstLogin = () => {
        const data = JSON.stringify({
            email: email,
            currentPass: passwordCurrent,
            newPass: passwordNew,
            confPass: passwordConfirm,
        });

        const config = {
            method: 'post',
            url: `${process.env.REACT_APP_BASE_ENDPOINT_BACKEND}/assesor/first-login`,
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': getApiKey
            },
            data: data,
        };

        axios(config).then((response) => {
            // const hasil = response
            // const modifHasil = {
            //     ...hasil,
            //     results: {
            //         ...hasil.results,
            //         nama: hasil.results.nama,
            //         email: hasil.results.email
            //     }
            // };
            

            window.location.reload();
            setModalChangePassword(false);
        }).catch((error) => {
            if (error.response && error.response.data && error.response.data.error) {
                const errorCode = error.response.data.error;
                const message = getErrorMessage(errorCode);
                setErrorMessageChange(message);
                setErrorChange(false);
                setTimeout(() => {
                    setErrorChange(true)
                    setErrorMessageChange('')
                }, 5000)
            } else {
                setErrorMessageChange("Terjadi kesalahan. Silakan coba kembali.");
                setErrorChange(false);
                setTimeout(() => {
                    setErrorChange(true)
                    setErrorMessageChange('')
                }, 5000)
            }
        })
    }

    



    return (
        <React.Fragment>
            <style>
                {`
                    @keyframes slideDown {
                        from {
                            opacity: 0;
                            transform: translateY(-10px);
                            max-height: 0;
                        }
                        to {
                            opacity: 1;
                            transform: translateY(0);
                            max-height: 100px;
                        }
                    }
                `}
            </style>
            <Row style={{ margin: '0px', height: '100vh', alignItems: 'center' }}>
                {/* Ini Welcome! Lets Get Started */}
                <Col md={12} lg={6} xl={6} style={{ height: '100%', padding: '0px' }}>
                    <img src={Welcome} style={{ height: '-webkit-fill-available' }} alt="Welcome" />
                </Col>

                <Col md={12} lg={6} xl={6} style={{ padding: '0px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>

                    <div style={{ display: 'flex', justifyContent: 'center', marginRight: '50px' }}>
                        <img src={logoTelkom} alt="logoTelkom" />
                    </div>

                    <div style={{ marginTop: '50px', padding: '25px', boxShadow: '0px 4px 15px rgba(0, 0, 0, 0.08)', borderRadius: '8px', width: '65%', marginRight: '50px' }}>
                        <p style={{ fontWeight: '700', fontSize: '30px', color: '#F56565', textAlign: 'center' }}>Masuk</p>
                        {!errorSubmit && errorMessage && (
                            <Alert 
                                color="danger" 
                                style={{ 
                                    textAlign: 'center', 
                                    backgroundColor: '#FEE2E2', 
                                    color: '#DC2626', 
                                    borderColor: '#FCA5A5', 
                                    borderLeft: '4px solid #DC2626',
                                    margin: '10px 0px 20px 0px', 
                                    borderRadius: '6px',
                                    padding: '12px 16px',
                                    fontSize: '14px',
                                    fontWeight: '500',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: '8px',
                                    animation: 'slideDown 0.3s ease-out',
                                    boxShadow: '0 2px 4px rgba(220, 38, 38, 0.1)'
                                }}
                                onClose={() => {
                                    setErrorSubmit(true);
                                    setErrorMessage('');
                                }}
                                toggle={() => {
                                    setErrorSubmit(true);
                                    setErrorMessage('');
                                }}
                            >
                                <i className="ri-error-warning-line" style={{ fontSize: '18px' }}></i>
                                {errorMessage}
                            </Alert>
                        )}

                        <div className="mb-3">
                            <Label htmlFor="email" className="form-label">Email</Label>
                            <Input type="text" value={email} onChange={changeEmail} className="form-control" id="email" placeholder="Enter Email" required />
                            {errorEmail && (
                                <p style={{ margin: '0', color: '#F56565', fontSize: '10px', position: 'absolute' }}>{errorEmail}</p>
                            )}
                        </div>

                        <div className="mb-3">
                            <Label className="form-label" htmlFor="password-input">Password</Label>
                            <div className="position-relative auth-pass-inputgroup">
                                <Input type={showPass ? "text" : "password"} value={password} onChange={changePassword} className="form-control pe-5" placeholder="Enter password" id="password-input" required />
                                <button className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted" onClick={shower} type="button" id="password-addon"><i className="ri-eye-fill align-middle"></i></button>
                            </div>
                            {errorPassword && (
                                <p style={{ margin: '0', color: '#F56565', fontSize: '10px', position: 'absolute' }}>{errorPassword}</p>
                            )}
                        </div>

                        {/* <ReCAPTCHA sitekey={process.env.REACT_APP_SITE_KEY} ref={captchaRef} /> */}

                        <div className="mt-4">
                            <Button color="success" className="w-100" onClick={loginButton}>Masuk</Button>
                        </div>
                    </div>
                </Col>
            </Row>

            {/* ------- MODAL CAPTCHA ------- */}
            {/* <Modal isOpen={modalReCAPTCHA} toggle={() => { }} centered>
                <ModalBody style={{ display: "flex", flexDirection: "column", alignItems: "center", overflow: "auto" }}>
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <h5 style={{ textAlign: "center", padding: "0 70px", margin: '50px 0px' }}>
                            reCAPTCHA dulu kawan
                        </h5>
                        <Button color="success" onClick={() => { setModalReCAPTCHA(false) }}>Oke Deh</Button>
                    </div>
                </ModalBody>
            </Modal> */}

            <Modal isOpen={modalChangePassword} toggle={() => { }} centered>

                <ModalBody style={{ display: "flex", flexDirection: "column", alignItems: "center", overflow: "auto" }}>
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <img src={logoTelkom} alt="logoTelkom" />
                        </div>
                        <div style={{ padding: "0px 5%", display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <h2 style={{ textAlign: "center", margin: '20px 0px', fontWeight: '700' }}>
                                Selamat Datang di Web Interview Telkom ACI Assessor
                            </h2>
                            <p style={{ fontSize: '14px', textAlign: 'center' }}>Silahkan untuk menganti password setelah di berikan oleh Admin, pastikan anda selalu mengingatnya yaa...</p>
                            {!errorChange && errorMessageChange && (
                                <Alert 
                                    color="danger" 
                                    style={{ 
                                        textAlign: 'center', 
                                        backgroundColor: '#FEE2E2', 
                                        color: '#DC2626', 
                                        borderColor: '#FCA5A5', 
                                        borderLeft: '4px solid #DC2626',
                                        margin: '10px 0px 20px 0px', 
                                        borderRadius: '6px',
                                        padding: '12px 16px',
                                        fontSize: '14px',
                                        fontWeight: '500',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: '8px',
                                        width: '100%',
                                        animation: 'slideDown 0.3s ease-out',
                                        boxShadow: '0 2px 4px rgba(220, 38, 38, 0.1)'
                                    }}
                                    onClose={() => {
                                        setErrorChange(true);
                                        setErrorMessageChange('');
                                    }}
                                    toggle={() => {
                                        setErrorChange(true);
                                        setErrorMessageChange('');
                                    }}
                                >
                                    <i className="ri-error-warning-line" style={{ fontSize: '18px' }}></i>
                                    {errorMessageChange}
                                </Alert>
                            )}
                            <div className="mb-3" style={{ width: '100%', fontSize: '14px' }}>
                                <Label className="form-label" htmlFor="password-input">Current Password</Label>
                                <div className="position-relative auth-pass-inputgroup">
                                    <Input type={showPass ? "text" : "password"} value={passwordCurrent} onChange={changePasswordCurrent} className="form-control pe-5" placeholder="Enter password" id="password-input" required />
                                    <button className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted" onClick={shower} type="button" id="password-addon"><i className="ri-eye-fill align-middle"></i></button>
                                </div>
                                {errorPassword && (
                                    <p style={{ margin: '0', color: '#F56565', fontSize: '10px', position: 'absolute' }}>{errorPassword}</p>
                                )}
                            </div>
                            <div className="mb-3" style={{ width: '100%', fontSize: '14px' }}>
                                <Label className="form-label" htmlFor="password-input">New Password</Label>
                                <div className="position-relative auth-pass-inputgroup">
                                    <Input type={showPass ? "text" : "password"} value={passwordNew} onChange={changePasswordNew} className="form-control pe-5" placeholder="Enter password" id="password-input" required />
                                    <button className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted" onClick={shower} type="button" id="password-addon"><i className="ri-eye-fill align-middle"></i></button>
                                    <p style={{ margin: '0', color: '#ED8936', fontSize: '10px' }}>*Kata sandi minimal 8 karakter harus terdiri atas huruf kapital, angka, dan simbol.</p>
                                </div>
                                {errorPassword && (
                                    <p style={{ margin: '0', color: '#F56565', fontSize: '10px', position: 'absolute' }}>{errorPassword}</p>
                                )}
                            </div>
                            <div className="mb-3" style={{ width: '100%', fontSize: '14px' }}>
                                <Label className="form-label" htmlFor="password-input">Confirm Password</Label>
                                <div className="position-relative auth-pass-inputgroup">
                                    <Input type={showPass ? "text" : "password"} value={passwordConfirm} onChange={changePasswordConfirm} className="form-control pe-5" placeholder="Enter password" id="password-input" required />
                                    <button className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted" onClick={shower} type="button" id="password-addon"><i className="ri-eye-fill align-middle"></i></button>
                                </div>
                                {errorPassword && (
                                    <p style={{ margin: '0', color: '#F56565', fontSize: '10px', position: 'absolute' }}>{errorPassword}</p>
                                )}
                            </div>
                        </div>

                        <Button color="success" onClick={() => { firstLogin() }}>Change Password</Button>
                    </div>
                </ModalBody>
            </Modal>

            <Modal isOpen={modalLimitLogin} toggle={() => { }} centered>
                <ModalBody style={{ display: "flex", flexDirection: "column", alignItems: "center", overflow: "auto" }}>
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <h5 style={{ textAlign: "center", padding: "0 50px", margin: '50px 0px' }}>
                            Terlalu banyak melakukan percobaan,<br />Mohon tunggu beberapa menit
                        </h5>
                        <Button color="success" onClick={() => { setModalLimitLogin(false) }}>Oke Deh</Button>
                    </div>
                </ModalBody>
            </Modal>

            <Modal isOpen={modalOTP} toggle={() => { }} centered>
                <ModalBody style={{ display: "flex", flexDirection: "column", alignItems: "center", overflow: "auto", padding: '30px' }}>
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", width: '100%' }}>
                        <p style={{fontWeight: '700', fontSize: '30px', color: '#F56565', textAlign: 'center', marginBottom: '20px'}}>Verifikasi OTP</p>

                        {!errorOTP && errorMessageOTP && (
                            <Alert 
                                color="danger" 
                                style={{ 
                                    textAlign: 'center', 
                                    backgroundColor: '#FEE2E2', 
                                    color: '#DC2626', 
                                    borderColor: '#FCA5A5', 
                                    borderLeft: '4px solid #DC2626',
                                    margin: '0px 0px 20px 0px', 
                                    borderRadius: '6px',
                                    padding: '12px 16px',
                                    fontSize: '14px',
                                    fontWeight: '500',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: '8px',
                                    width: '100%',
                                    animation: 'slideDown 0.3s ease-out',
                                    boxShadow: '0 2px 4px rgba(220, 38, 38, 0.1)'
                                }}
                                onClose={() => {
                                    setErrorOTP(true);
                                    setErrorMessageOTP('');
                                }}
                                toggle={() => {
                                    setErrorOTP(true);
                                    setErrorMessageOTP('');
                                }}
                            >
                                <i className="ri-error-warning-line" style={{ fontSize: '18px' }}></i>
                                {errorMessageOTP}
                            </Alert>
                        )}

                        <div style={{display: 'flex', justifyContent: 'center', width: '100%'}}>
                            <ReactInputVerificationCode value={otp} onChange={(value) => {
                                setOTP(value);
                                // Reset error when user starts typing
                                if (errorMessageOTP) {
                                    setErrorOTP(true);
                                    setErrorMessageOTP('');
                                }
                            }}/>
                        </div>
                        
                        <p style={{textAlign: 'center', marginTop: '20px', fontSize: '14px'}}> 
                            Anda masuk belum menerima kode? 
                            <span style={{fontWeight: '700', fontSize: '16px', color: '#F56565', cursor: 'pointer', marginLeft: '4px'}} onClick={() => {
                                setErrorOTP(true);
                                setErrorMessageOTP('');
                                loginButton();
                                }}>Kirim Ulang</span>
                        </p>
                        
                        <div className="text-center mt-2" style={{width: '100%'}}>
                            <Button style={{fontSize: '14px'}} color="success" className="w-100" onClick={() => {
                                verifyOTP();
                                // onNext(); 
                                }}>
                                Verifikasi
                            </Button>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        </React.Fragment>
    );
};

export default CoverSignInterview;